/**
 * Protection des images du site public.
 *
 * Décourage les deux gestes les plus courants : le glisser-déposer d'une photo
 * vers le bureau et le clic droit > "Enregistrer l'image sous".
 *
 * Limites connues et assumées : cela n'empêche ni la capture d'écran, ni
 * l'ouverture directe de l'URL du fichier (/uploads/...), ni les DevTools, ni
 * les extensions de téléchargement. Seuls le filigrane et la limitation de
 * résolution protègent contre un visiteur déterminé.
 *
 * Le back-office est exclu : le réordonnancement des galeries repose sur le
 * glisser-déposer natif et l'admin doit pouvoir enregistrer ses propres images.
 */

const ADMIN_SELECTOR = '.project-manager, .admin-login, .cropper-modal';

const isProtectedImage = (target) =>
  target instanceof Element &&
  target.tagName === 'IMG' &&
  !target.closest(ADMIN_SELECTOR);

/**
 * Installe les écouteurs sur le document.
 * @returns {function} fonction de nettoyage à appeler au démontage
 */
export function installImageProtection() {
  const block = (event) => {
    if (isProtectedImage(event.target)) {
      event.preventDefault();
    }
  };

  document.addEventListener('contextmenu', block);
  document.addEventListener('dragstart', block);

  return () => {
    document.removeEventListener('contextmenu', block);
    document.removeEventListener('dragstart', block);
  };
}
